import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dashboard-missions-advancement',
  templateUrl: './dashboard-missions-advancement.component.html',
  styleUrls: ['./dashboard-missions-advancement.component.scss']
})
export class DashboardMissionsAdvancementComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
